// extracted by mini-css-extract-plugin
export default {"wrapper":"rating_wrapper__CaL5F","star":"rating_star__IhtSk","ratingScore":"rating_ratingScore__qBqkA","guestReview":"rating_guestReview__bLPCV"};